import {NoticeStatus} from "../../../../shared/enums/noticeStatus";

export default class NoticesDataListItem {
  id: string;
  notice: string;
  status: NoticeStatus;
  publishDate: Date | null;
  author: string;
  readCount: number | null;
  notificationDate: Date | null;
  notificationEnabled: boolean;
  isMultiVillage?: boolean | null;
  villageIds: string[] | null;
  isAnnouncement?: boolean | null;
  isImportant?: boolean | null;
  // Person type ids the notice targets. Null/empty means independent-only
  // (the legacy backend audience default).
  personTypes?: string[] | null;

  constructor(
    id: string,
    notice: string,
    status: NoticeStatus,
    publishDate: Date | null,
    author: string,
    readCount: number | null,
    villageIds: string[] | null,
    notificationDate: Date | null,
    isMultiVillage?: boolean | null,
    isAnnouncement?: boolean | null,
    isImportant?: boolean | null,
    personTypes?: string[] | null
  ) {
    this.id = id;
    this.notice = notice;
    this.status = status;
    this.publishDate = publishDate;
    this.author = author;
    this.readCount = readCount;
    this.villageIds = villageIds;
    this.notificationDate = notificationDate;
    this.notificationEnabled = !!notificationDate;
    this.isMultiVillage = isMultiVillage;
    this.isAnnouncement = isAnnouncement;
    this.isImportant = isImportant;
    this.personTypes = personTypes;
  }
}
